export const TableSize = {
  SMALL: 'p-datatable-sm',
  NORMAL: '',
  LARGE: 'p-datatable-lg',
} as const

export const ADMIN = {
  MAX_TABLE_ROWS: 10,
  MAX_TABLE_PAGE_SIZES: [10,15,20,25],
  MAX_DETAIL_TABLE_ROWS: 4,
  MAX_DETAIL_TABLE_PAGE_SIZES: [4,5,8,10,15],
}

export const DRIVER = {
  MAX_TABLE_ROWS: 10,
  MAX_TABLE_PAGE_SIZES: [10,15,20,25],
}
